import SectionRemoved from './SectionRemoved'

export default SectionRemoved
// eslint-disable-next-line import/export
export * from './SectionRemoved'
